import { clients } from '@oncolens/oncolens-ui/lib/api/client';
import {
  ApiListResponse,
  PagedApiResponse,
  Pagination,
} from '@oncolens/oncolens-ui/lib/dto/api/ApiResponse';
import { AxiosResponse } from 'axios';
import queryString from 'query-string';
import { useQuery } from 'react-query';
import { OrganizationDto, QueryParams } from '../types';
import { OrganizationKeys } from './organization.keys';

interface LegacyLookupDto {
  legacyTable: string;
  legacyId: string;
}

export function getOrganizationsWithSsoConnections(includeSsoConnection = false) {
  // eslint-disable-next-line @typescript-eslint/no-shadow
  return (queryString: string) =>
    getOrganizations(
      includeSsoConnection ? `${queryString}&includeSsoConnection=true` : queryString,
    );
}

// eslint-disable-next-line @typescript-eslint/no-shadow
export async function getOrganizations(queryString: string) {
  // eslint-disable-next-line no-param-reassign, eqeqeq
  queryString = queryString == '' ? queryString : `?${queryString}`;

  return clients.admin
    .get(`/organizations${queryString}`)
    .then((response: AxiosResponse<ApiListResponse<OrganizationDto>>) => {
      const { data } = response.data as ApiListResponse<OrganizationDto>;
      return {
        data,
        pagination: JSON.parse(response.headers['x-pagination']) as Pagination,
      } as PagedApiResponse<OrganizationDto>;
    });
}

// eslint-disable-next-line @typescript-eslint/no-shadow
export async function getAllOrganizations(queryString: string) {
  // eslint-disable-next-line no-param-reassign, eqeqeq
  queryString = queryString == '' ? queryString : `?${queryString}`;

  return clients.admin
    .get(`/organizations${queryString}`)
    .then((response: AxiosResponse<ApiListResponse<OrganizationDto>>) => {
      const { data } = response.data as ApiListResponse<OrganizationDto>;
      return data;
    });
}

const getEntireOrgList = async (pageNo = 1) => {
  const results = await getAllOrganizations(`pageNumber=${pageNo}&pageSize=100&SortOrder=name`);
  if (results.length > 0) {
    const nextPage: OrganizationDto[] = await getEntireOrgList(pageNo + 1);
    return results.concat(nextPage);
  }
  return results;
};

export function useOrganizations({
  pageNumber,
  pageSize,
  filters,
  sortOrder,
  includeParentOrg = true,
  includeSsoConnection = false,
  options,
}: QueryParams<PagedApiResponse<OrganizationDto>>) {
  const queryParams = queryString.stringify({
    pageNumber,
    pageSize,
    filters,
    sortOrder,
    includeParentOrg,
    includeSsoConnection,
  });
  return useQuery(OrganizationKeys.list(queryParams), () => getOrganizations(queryParams), options);
}

export function useGetEntireOrgList() {
  return useQuery(OrganizationKeys.entireList(), () => getEntireOrgList());
}

export async function getLegacyOrganizationId(organizationId: string) {
  return clients.admin
    .get(`/legacylookups/${organizationId}/byEntity?tableName=hospital_network`)
    .then((response) => response.data as LegacyLookupDto);
}
